import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  getTopAndVisibleDomains,
  getViewForChart,
  getViewGroupForChart,
  getVisibleEntriesForView,
} from '../../redux/sonar/sonarSelectors';
import { RELEVANCE_ALL_VIEWS, SONAR_SECTIONS, VIEWS } from '../../constants';
import { SONAR_DATA_KEYS, getSortingByStat } from '../../utils/chart';
import { Panel } from '../../components/layout/layout';
import WithToolbarWrapper from '../with-toolbar-wrapper/WithToolbarWrapper';
import ExtendedViewToolbar from '../extended-view-toolbar/ExtendedViewToolbar';
import ScatterChart from '../../components/charts/d3/scatter/ScatterChart';

const CHART_INDEX = 1;

function RelevanceAll() {
  const { t } = useTranslation('sonar');

  const view = useSelector(getViewForChart(SONAR_SECTIONS.RELEVANCE, CHART_INDEX));
  const group = useSelector(getViewGroupForChart(SONAR_SECTIONS.RELEVANCE, CHART_INDEX));

  const domainEntries = useSelector(getEntriesSelector(view, group));

  const viewOptions = [
    {
      label: t('topByBreadth', { size: 10 }),
      value: RELEVANCE_ALL_VIEWS.TOP_10_RELEVANCE_BREADTH,
    },
    {
      label: t('topByStrength', { size: 10 }),
      value: RELEVANCE_ALL_VIEWS.TOP_10_RELEVANCE_STRENGTH,
    },
    {
      label: t('topByBreadth', { size: 20 }),
      value: RELEVANCE_ALL_VIEWS.TOP_20_RELEVANCE_BREADTH,
    },
    {
      label: t('topByStrength', { size: 20 }),
      value: RELEVANCE_ALL_VIEWS.TOP_20_RELEVANCE_STRENGTH,
    },
    { label: t('focus'), value: VIEWS.FOCUS },
    { label: t('all'), value: VIEWS.ALL },
    { label: t('groups'), value: VIEWS.GROUPS },
  ];

  //! TEMPORARY SOLUTION
  let tempDomainEntries = domainEntries;

  if (
    domainEntries.length &&
    (!domainEntries[0][SONAR_DATA_KEYS.RELEVANCE_BREADTH] || !domainEntries[0][SONAR_DATA_KEYS.RELEVANCE_STRENGTH])
  ) {
    tempDomainEntries = [];
  }

  return (
    <Panel>
      <WithToolbarWrapper>
        <ExtendedViewToolbar
          chartIndex={CHART_INDEX}
          section={SONAR_SECTIONS.RELEVANCE}
          viewOptions={viewOptions}
          allowGroupsFilter
          disableChartTypes>
          {() => (
            <ScatterChart
              data={tempDomainEntries}
              xLabel={t('breadth')}
              yLabel={t('strength')}
              dataKeys={[SONAR_DATA_KEYS.RELEVANCE_BREADTH, SONAR_DATA_KEYS.RELEVANCE_STRENGTH]}
            />
          )}
        </ExtendedViewToolbar>
      </WithToolbarWrapper>
    </Panel>
  );
}

const ADDITIONAL_VIEW_SELECTORS = {
  [RELEVANCE_ALL_VIEWS.TOP_10_RELEVANCE_BREADTH]: getTopAndVisibleDomains(
    10,
    getSortingByStat(SONAR_DATA_KEYS.RELEVANCE_BREADTH),
  ),
  [RELEVANCE_ALL_VIEWS.TOP_10_RELEVANCE_STRENGTH]: getTopAndVisibleDomains(
    10,
    getSortingByStat(SONAR_DATA_KEYS.RELEVANCE_STRENGTH),
  ),
  [RELEVANCE_ALL_VIEWS.TOP_20_RELEVANCE_BREADTH]: getTopAndVisibleDomains(
    20,
    getSortingByStat(SONAR_DATA_KEYS.RELEVANCE_BREADTH),
  ),
  [RELEVANCE_ALL_VIEWS.TOP_20_RELEVANCE_STRENGTH]: getTopAndVisibleDomains(
    20,
    getSortingByStat(SONAR_DATA_KEYS.RELEVANCE_STRENGTH),
  ),
};

function getEntriesSelector(view, group) {
  return ADDITIONAL_VIEW_SELECTORS[view] || getVisibleEntriesForView(view, group);
}

export default RelevanceAll;
